import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { FilterTable } from 'gnos-tables'
import _ from 'lodash'

import CellStyleWrapper from '../../../../../../../../../../../components/TableCell/components/CellStyleWrapper'
import Signals from '../../../../../../../../../../../components/TableCell/components/Signals'
import Entity from '../../../../../../../../../../../components/TableCell/components/Entity'
import Flag from '../../../../../../../../../../../components/TableCell/components/Flag'
import NoData from '../../../../../../../../../components/Workspace/components/NoData'
import CustomDate from '../../../../../../../../../../../components/CustomDate'

import { LOCALE_PREFIX } from '../../constants'

import hocConnect from './hocConnect'
import './style.scss'

@injectIntl
@hocConnect
export default class BeneficialOwners extends Component {
    static propTypes = {
        blockKey: PropTypes.string.isRequired,
        data: PropTypes.array,
        filter: PropTypes.object,
        locked: PropTypes.bool,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        isLoading: PropTypes.bool,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        pagination: PropTypes.object,
        personsBeneficialOwnersChanged: PropTypes.func.isRequired,
        sorted: PropTypes.array,
    }

    getColumnsDefinition = () => {
        const { intl } = this.props

        return [
            {
                accessor: 'subject',
                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.subject` }),
                Cell: ({ value, original }) => (
                    <div className={'persons-table-entity-cell'}>
                        <CellStyleWrapper isCentered>
                            {value?.countryIso !== 'CZ' && !_.isNil(value?.countryIso) && (
                                <Flag country={_.lowerCase(value?.countryIso)} />
                            )}
                            <Entity
                                entity={value}
                                entId={value?.id}
                                inactive={value?.inactive}
                                type={value?.type}
                                value={value?.name}
                                rowInactive={original?.inactive}
                            />
                        </CellStyleWrapper>
                    </div>
                ),
            },
            {
                id: 'indicators',
                accessor: 'subject',
                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.indicators` }),
                Cell: ({ value, original }) => (
                    <CellStyleWrapper isNotActive={original?.inactive}>
                        <Signals
                            id={value?.id}
                            caution={value?.indicators?.caution}
                            risk={value?.indicators?.risk}
                            notice={value?.indicators?.notice}
                        />
                    </CellStyleWrapper>
                ),
                width: 200,
            },
            {
                id: 'type',
                accessor: 'type',
                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.type` }),
                Cell: ({ value, original }) => (
                    <CellStyleWrapper isNotActive={original?.inactive}>
                        <span>{value}</span>
                    </CellStyleWrapper>
                ),
            },
            {
                id: 'percentage',
                accessor: 'percentage',
                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.shareSize` }),
                Cell: ({ value, original }) => (
                    <CellStyleWrapper isNotActive={original?.inactive}>
                        <span>{!value ? 'N/A' : `${value} %`}</span>
                    </CellStyleWrapper>
                ),
            },
            {
                id: 'startDate',
                accessor: 'startDate',
                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.dateFrom` }),
                Cell: ({ value, original }) => (
                    <CellStyleWrapper isNotActive={original?.inactive}>
                        <CustomDate date={value?.value} precision={value?.precision} />
                    </CellStyleWrapper>
                ),
                width: 100,
            },
        ]
    }

    onTableChange = (tableChange) => {
        const { module, blockKey, id, level, personsBeneficialOwnersChanged } = this.props

        personsBeneficialOwnersChanged(module, blockKey, id, level, tableChange)
        return null
    }

    render() {
        const { id, data, isLoading, locked, pagination, sorted, filter, intl } = this.props

        if (locked) {
            return (
                <div className={'persons-representatives-block'}>
                    <NoData text={intl.formatMessage({ id: `${LOCALE_PREFIX}.lockedTab` })} />
                </div>
            )
        }

        if (_.isEmpty(data) && _.isEmpty(filter?.activeFilters)) {
            return (
                <div className={'persons-representatives-block'}>
                    <NoData text={intl.formatMessage({ id: `${LOCALE_PREFIX}.noData` })} />
                </div>
            )
        }

        return (
            <div className={'persons-beneficial-owners-block'}>
                <FilterTable
                    id={`persons-beneficial-owners-table-${id}`}
                    columnsDefinition={this.getColumnsDefinition()}
                    data={data ?? []}
                    onTableChange={this.onTableChange}
                    loading={isLoading}
                    settings={{
                        pagination,
                        sorted,
                        filtered: (filter?.activeFilters ?? []).map((actFilter) => ({
                            id: actFilter?.id,
                            value: actFilter?.value || [],
                        })),
                    }}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    texts={{
                        pagination: {
                            page: intl.formatMessage({ id: 'global.page' }),
                            from: intl.formatMessage({ id: 'global.of' }),
                            rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                            rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                            all: intl.formatMessage({ id: 'global.all' }),
                        },
                        filter: {
                            valueTitle: intl.formatMessage({ id: 'global.valueTitle' }),
                            fulltextTitle: intl.formatMessage({ id: 'global.fulltextTitle' }),
                        },
                    }}
                />
            </div>
        )
    }
}
